import styled from 'styled-components';

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem;
    margin: 2.3rem 0 2.3rem 0;
`;

export const PageContent = styled.div`
    width: 100%;
`;
